import { get_recording_overview } from "../../api";
import { useKeyedRequest } from "../../utils/useKeyedRequest";
import { localDayBounds } from "./dateSelection";

/** Sessions started within the picked local days, `from` and `to` inclusive. */
export function useSessionsOverview(
  from: string,
  to: string,
  revision: number,
  userIds?: string[],
  enabled = true,
) {
  const userIdList = userIds ? [...userIds].sort().join(",") : undefined;
  const { data, loading, failed, reload } = useKeyedRequest(
    enabled ? JSON.stringify([from, to, revision, userIdList]) : null,
    () =>
      get_recording_overview({
        ...localDayBounds(from, to),
        ...(userIdList !== undefined ? { user_id_list: userIdList } : {}),
      }),
  );
  return { data, loading, failed, reload };
}
